import useTicketCardService from "./service";
import { TicketCardPropTypes } from "./types";
import { ComposedIcons } from "assets/icons/icons.compose";
import { TicketBody, TicketFooter, TicketHeader } from "./components";

function TicketCard(props: TicketCardPropTypes) {
  const service = useTicketCardService(props);

  return (
    <div className="ticketCard">
      <div className="ticketCard_headerBorder">
        <ComposedIcons.TicketBorder />
      </div>
      <TicketHeader title={props.title} ticketDisplayColour={props.ticketDisplayColour} />
      <div className="ticketCard_rip">
        <div className="ticketCard_rip--border"></div>
      </div>
      <TicketBody
        description={props.description}
        isCurrentTicket={service.isCurrentTicket}
        existingPrivileges={props.existingPrivileges}
        availablePrivileges={props.availablePrivileges}
      />
      {!service.isCurrentTicket && (
        <TicketFooter
          id={props.id}
          title={props.title}
          subRole={props.subRole}
          localeId={props.localeId}
          ticketUrl={props.ticketUrl}
          paymentFlow={props.paymentFlow}
          workflowType={props.workflowType}
          currentPrice={props.currentPrice}
          applicableRate={props.applicableRate}
          applicationFlow={props.applicationFlow}
          priceDifference={props.priceDifference}
          termsAndConditions={props.termsAndConditions}
          ticketCardFlowType={props.ticketCardFlowType}
          bulkPurchaseAllowed={props.bulkPurchaseAllowed}
          ticketDisplayColour={props.ticketDisplayColour}
          showSingleBuyButtonAtOnce={props.showSingleBuyButtonAtOnce}
          buyTicketClickHandler={props.buyTicketClickHandler}
        />
      )}
      <div className="ticketCard_footerBorder">
        <ComposedIcons.TicketBorder />
      </div>
    </div>
  );
}

export default TicketCard;
